import { render, staticRenderFns } from "./Line-Item.vue?vue&type=template&id=71078e70"
import script from "./Line-Item.vue?vue&type=script&lang=js"
export * from "./Line-Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports